/*
 * Copyright (c) 2022 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import { LDUser } from "launchdarkly-js-client-sdk";

export interface IGatewayDetails {
  details: IGatewayDetail[];
  userInfo: LDUser;
  appliance: IApplianceDetails;
}

export class IGatewayDetail {
  key?: string;
  gatewayName: string = "";
  serialNumber: string = "";
  gatewayType: string = "";
  externalId: string = "";
  gatewayStatus: string = "";
  softwareInfo: string = "";
  onSelectCall?: () => void;
  selected?: boolean;
}

export interface IGatewayAddress {
  address1: string;
  address2: string;
}

export interface IApplianceDetails {
  serialNumber: string;
  originalEndpoint: string;
  enrollmentId: string;
}
